import { Avatar, CircularProgress, TableCell, TableRow } from "@mui/material";
import { Box } from "@mui/system";
import MUIDataTable from "mui-datatables";
import React, { useContext, useEffect, useState } from "react";
import CourseAssignmentContext from "../../context/500/CourseAssignmentContext";
import ProfileContext from "../../context/ProfileContext";
import useAuth from "../../hooks/useAuth";
import StaffCourseOffering from "./StaffCourseOffering";

function StaffComponent() {
  let {
    staffs,
    staffData,
    assign,
    assignStaffThoughClick,
    setshowSection,
    showSection,
    setAssigned,
    getStaffs,
  } = useContext(CourseAssignmentContext);
  let [loading, setLoading] = useState(false);
  let [isMounted, setIsMounted] = useState(true);

  let {state}=useContext(ProfileContext)
  let {user}=useAuth()
  

  useEffect(() => {
    setIsMounted(true);
    const controller = new AbortController();

    getStaffs(isMounted, controller.signal);

    return () => {
      setIsMounted(false);
      controller.abort();
    };
  }, []);

  function viewAssignColumn() {
    let view = false;
    if (assign.courseCode != null) {
      view = true;
    }
    return view;
  }

  async function handleAssign(sid) {
    let msg = await assignStaffThoughClick(sid);

    setLoading(true);
    if (msg === true) {
      getStaffs(true);
      setshowSection({ ...showSection, courseCode: assign.course_code });

      setAssigned({});
      setLoading(false);
    } else {
      alert(msg);
    }
  }

  function assignColorForStatus(stat) {
    let color = "white";

    if (stat.trim().toLowerCase() === "full time") {
      color = "rgb(66, 207, 66)";
    } else if (stat.trim().toLowerCase() === "part time") {
      color = "#cd853f";
    }

    return color;
  }

  const columns = [
    {
      name: "Img",
      options: {
        filter: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                display: "flex",
                justifyContent: "flex-around",
                alignItems: "center",
                cursor: "pointer",
              }} 
              draggable
              onDragStart={(e) => {
                e.dataTransfer.setData("staffId", value.id);
              }}
            >
              <Avatar

                src={state.host+value?.pic?.slice(1,)+`?token=${user?.accessToken}`}
                // src={require(`../../assets${value.pic}`)}
                alt="profile picture"
                sx={{
                  width: "50px",
                  height: "50px"
                }}
              />
            </div>
          );
        },
      },
    },
    {
      name: "Name",
      options: {
        filter: false,
      },
    },
    {
      name: "Status",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box
              sx={{
                borderColor: "none",

                color: "rgb(234, 234, 234)",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  backgroundColor: assignColorForStatus(value),
                  borderColor: "none",
                  borderRadius: "5px",
                  padding: "5px 5px",
                  textAlign: "center",
                }}
              >
                {value}
              </div>
            </Box>
          );
        },
      },
    },
    {
      name: "A.Rank",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div
              style={{
                width: "100%",
                height: "100%",

                borderColor: "none",

                padding: "5px 5px",
                textAlign: "center",
              }}
            >
              {value}
            </div>
          );
        },
      },
    },
    {
      name: "Total.Load",
      options: {
        filter: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div
              style={{
                width: "100%",
                height: "100%",

                borderColor: "none",

                padding: "5px 5px",
                textAlign: "center",
              }}
            >
              {value}
            </div>
          );
        },
      },
    },
    {
      name: "Reg.Load",
      options: {
        filter: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div
              style={{
                width: "100%",
                height: "100%",

                borderColor: "none",

                padding: "5px 5px",
                textAlign: "center",
              }}
            >
              {value}
            </div>
          );
        },
      },
    },
    {
      name: "Ext.Load",
      options: {
        filter: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div
              style={{
                width: "100%",
                height: "100%",

                borderColor: "none",

                padding: "5px 5px",
                textAlign: "center",
              }}
            >
              {value}
            </div>
          );
        },
      },
    },
    {
      name: "Action",
      options: {
        filter: false,
        display: viewAssignColumn(),
        viewColumns: viewAssignColumn(),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div
              style={{
                width: "100%",
                height: "100%",
                backgroundColor: "#cd853f",
                borderColor: "none",
                borderRadius: "5px",
                padding: "3px 0px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                handleAssign(value.id);
              }}
            >
              {value.assign}
            </div>
          );
        },
      },
    },
    {
      name: "id",
      options: {
        filter: false,
        display: false,
        viewColumns: false,
      },
    },
  ];

  const options = {
    print: "false",
    download: "false",
    filterType: "dropdown",
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 15],
    pagination: true,
    responsive: "vertical",
    selectableRows: "none",
    expandableRows: true,

    renderExpandableRow: (rowData, rowMeta) => {
      let currentstaff = staffs.filter((staff) => staff.id === rowData[8]);
      const colSpan = rowData.length + 1;

      return (
        <TableRow>
          <TableCell colSpan={colSpan}>
            <StaffCourseOffering sID={currentstaff[0].id} />
          </TableCell>
        </TableRow>
      );
    },
  };

  return (
    <div className="staffTableWrapper">
      {loading === false ? (
        <MUIDataTable
          title={"Staff List"}
          data={staffData}
          columns={columns}
          options={options}
        />
      ) : (
        <React.Fragment>
          {loading === true && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </Box>
          )}
        </React.Fragment>
      )}
    </div>
  );
}

export default StaffComponent;
